import { Alert, Center, Spinner } from '@chakra-ui/react'
import type { PropsWithChildren } from 'react'
import { Navigate, useLocation } from 'react-router'
import { isApiError } from '~/api/client'
import { useOrgMe } from '~/api/hooks'

/**
 * Guards organizer routes: 401 ⇒ /organizer/login?next=…; other errors (e.g. API not reachable yet)
 * render the page with a warning so UI work can proceed in parallel with the backend.
 */
export const RequireOrganizer = ({ children }: PropsWithChildren) => {
  const { isPending, error } = useOrgMe()
  const location = useLocation()

  if (isPending)
    return (
      <Center minH='100svh'>
        <Spinner />
      </Center>
    )
  if (error && isApiError(error) && error.status === 401) {
    const next = encodeURIComponent(location.pathname + location.search)
    return <Navigate to={`/organizer/login?next=${next}`} replace />
  }
  return (
    <>
      {error && (
        <Alert.Root status='warning' borderRadius={0}>
          <Alert.Indicator />
          <Alert.Title>Could not verify your session: {error.message}</Alert.Title>
        </Alert.Root>
      )}
      {children}
    </>
  )
}
